module.exports = __webpack_public_path__ + "static/media/notificationIcon.e05c43b0.svg";